/**
 * Self-Service Calculator
 *
 * Contact: dap@visana.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Defines a unique basic insurance model (except missing the configuration criteria as e.g. the franchise...)
 */
export type BasicInsuranceModelType = 'TRADITIONAL' | 'MANAGED_CARE' | 'MED_DIRECT' | 'CASA_NOVA' | 'TEL_DOC' | 'MED_CALL' | 'TEL_CARE' | 'COMBI_CARE' | 'VIVA';

export const BasicInsuranceModelType = {
    Traditional: 'TRADITIONAL' as BasicInsuranceModelType,
    ManagedCare: 'MANAGED_CARE' as BasicInsuranceModelType,
    MedDirect: 'MED_DIRECT' as BasicInsuranceModelType,
    CasaNova: 'CASA_NOVA' as BasicInsuranceModelType,
    TelDoc: 'TEL_DOC' as BasicInsuranceModelType,
    MedCall: 'MED_CALL' as BasicInsuranceModelType,
    TelCare: 'TEL_CARE' as BasicInsuranceModelType,
    CombiCare: 'COMBI_CARE' as BasicInsuranceModelType,
    Viva: 'VIVA' as BasicInsuranceModelType
};

